// Ekrany ładowane osobno (docs/pwa/PROJEKT.md 10, „najpierw to, co user widzi”): przy starcie przeglądarka pobiera
// tylko powłokę i bieżący ekran, pozostałe dociągają się w tle, gdy telefon nic nie robi - przejście do nich jest
// potem natychmiastowe. Ta sama funkcja ładuje ekran dla trasy i w tle (moduł pobierany raz).
import { lazy } from "react";

const ladujLogowanie = () => import("./Logowanie");
const ladujUrzadzenia = () => import("./Urzadzenia");
const ladujUstawienia = () => import("./Ustawienia");
const ladujPulpit = () => import("./Pulpit");
const ladujPulpity = () => import("./Pulpity");
const ladujStatystyki = () => import("./Statystyki");
const ladujEnergia = () => import("./Energia");
const ladujAlarmy = () => import("./Alarmy");
const ladujUdostepnianie = () => import("./Udostepnianie");
const ladujSerwis = () => import("./Serwis");
const ladujDodaj = () => import("./urzadzenia/Dodaj");
const ladujPrzepisy = () => import("./Przepisy");
const ladujFormularz = () => import("./przepisy/Formularz");
const ladujPlany = () => import("./Plany");
const ladujAsystent = () => import("./Asystent");
const ladujInstrukcje = () => import("./Instrukcje");
const ladujOsiagniecia = () => import("./Osiagniecia");
const ladujSerwisSprzetu = () => import("./SerwisSprzetu");

export const Pulpity = lazy(() => ladujPulpity().then((m) => ({ default: m.Pulpity })));
export const Logowanie = lazy(() => ladujLogowanie().then((m) => ({ default: m.Logowanie })));
export const Urzadzenia = lazy(() => ladujUrzadzenia().then((m) => ({ default: m.Urzadzenia })));
export const Ustawienia = lazy(() => ladujUstawienia().then((m) => ({ default: m.Ustawienia })));
export const Pulpit = lazy(() => ladujPulpit().then((m) => ({ default: m.Pulpit })));
export const Statystyki = lazy(() => ladujStatystyki().then((m) => ({ default: m.Statystyki })));
export const Energia = lazy(() => ladujEnergia().then((m) => ({ default: m.Energia })));
export const Alarmy = lazy(() => ladujAlarmy().then((m) => ({ default: m.Alarmy })));
export const Udostepnianie = lazy(() => ladujUdostepnianie().then((m) => ({ default: m.Udostepnianie })));
export const Serwis = lazy(() => ladujSerwis().then((m) => ({ default: m.Serwis })));
export const DodajUrzadzenie = lazy(() => ladujDodaj().then((m) => ({ default: m.DodajUrzadzenie })));
export const Przepisy = lazy(() => ladujPrzepisy().then((m) => ({ default: m.Przepisy })));
export const FormularzPrzepisu = lazy(() => ladujFormularz().then((m) => ({ default: m.FormularzPrzepisuEkran })));
export const SzczegolyPrzepisu = lazy(() => import("./przepisy/Szczegoly").then((m) => ({ default: m.SzczegolyPrzepisu })));
export const Plany = lazy(() => ladujPlany().then((m) => ({ default: m.Plany })));
export const Asystent = lazy(() => ladujAsystent().then((m) => ({ default: m.Asystent })));
export const Instrukcje = lazy(() => ladujInstrukcje().then((m) => ({ default: m.Instrukcje })));
export const Osiagniecia = lazy(() => ladujOsiagniecia().then((m) => ({ default: m.Osiagniecia })));
export const SerwisSprzetu = lazy(() => ladujSerwisSprzetu().then((m) => ({ default: m.SerwisSprzetu })));

// Moduły linii (karty wędzarni, kolumny) nie są tu - ładują się dopiero przy pulpicie danej linii.
const PO_ZALOGOWANIU = [ladujPulpity, ladujUrzadzenia, ladujUstawienia, ladujPulpit, ladujStatystyki, ladujEnergia,
  ladujAlarmy,ladujUdostepnianie, ladujSerwis, ladujDodaj, ladujPrzepisy, ladujPlany, ladujAsystent,
  ladujInstrukcje, ladujOsiagniecia, ladujSerwisSprzetu];

/** Dociąga w tle ekrany po zalogowaniu (po pierwszym malowaniu, w wolnej chwili przeglądarki). */
export function doladujWTle(): void {
  const start = () => {
    for (const laduj of PO_ZALOGOWANIU) void laduj().catch(() => undefined);
  };
  if ("requestIdleCallback" in window) window.requestIdleCallback(start, { timeout: 3000 });
  else setTimeout(start, 1500);
}
